<p class="text-underline">{{ 'help_and_support.returns.pvt_sellers.p1' | translate }}</p>
<p>{{ 'help_and_support.returns.pvt_sellers.p2' | translate }}</p>
<p>
  <span>{{ 'help_and_support.returns.pvt_sellers.p3_1' | translate }}</span>
  <a routerLink="/account/my-orders" class="link primary" target="_blank">
    {{ 'help_and_support.returns.pvt_sellers.p3_2' | translate }}
  </a>
  <span>{{ 'help_and_support.returns.pvt_sellers.p3_3' | translate }}</span>
</p>
<p>{{ 'help_and_support.returns.pvt_sellers.p4' | translate }}</p>
